﻿import { envConfig } from '../../../configs/env';

export function AirportSummaryIFrame(props: { url: string }) {
    return (
        <iframe
            data-auto-sync-theme
            className="w-100 h-100 min-h-100 flex-grow-1"
            src={props.url}
            allow={`clipboard-write ${envConfig.service}`}></iframe>
    );
}
